import actionTypes from 'redux/actions/actionTypes'

const defaultState = {
	userCredentials: {
		device_uid: '',
		rd: '',
	},
	awsCredentials: {
		s3AWSAccessKeyId: '',
		s3Expires: '',
		s3Signature: '',
	},
	slide_id: '',
	students: [],
	config: {
		_loaded: false,
	},
}

function initialize(state, action) {
	return {
		...state,
		userCredentials: action.userCredentials,
		awsCredentials: action.awsCredentials,
		slide_id: action.slide_id,
	}
}

function setConfig(state, action) {
	return {
		...state,
		config: {
			...action.config,
			_loaded: true,
		},
	}
}

function setStudentAnswers(state, action) {
	return {
		...state,
		students: action.students,
	}
}

const reducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.FILL_IN_THE_BLANKS_SESSION_INITIALIZE_ROUTE:
			return initialize(state, action)
		case actionTypes.FILL_IN_THE_BLANKS_SESSION_CONFIG_FETCHED:
			return setConfig(state, action)
		case actionTypes.FILL_IN_THE_BLANKS_SESSION_STUDENT_DATA_FETCHED:
			return setStudentAnswers(state, action)
		default: return state
	}
}

export default reducer
